module.exports = __webpack_public_path__ + "static/img/99-1.d7ef7ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/99-1.jpg
// module id = aLeq
// module chunks = 0